module.exports = __webpack_public_path__ + "img/medal4.c83276b3.png";